export default __webpack_public_path__ + "static/media/step-backward.518687fc.svg";